<template>
  <!-- Sin testimonios reales no se renderiza nada: el manual de marca prohíbe
       publicar prueba social sin respaldo (ver plan 22_08_2026, R3). -->
  <section v-if="testimonials.length" class="testimonials section" aria-labelledby="testimonials-heading">
    <header class="testimonials-head">
      <h2 id="testimonials-heading" class="testimonials-title">Lo que dicen quienes ya trabajaron con nosotros</h2>
      <p class="testimonials-intro">
        Casos reales de empresas, emprendedores y estudiantes que nos confiaron
        su proyecto.
      </p>
    </header>

    <ul class="testimonials-grid">
      <li v-for="item in testimonials" :key="item.id" class="testimonial-card">
        <Quote :size="28" :stroke-width="1.8" class="testimonial-icon" aria-hidden="true" />

        <blockquote class="testimonial-quote">{{ item.quote }}</blockquote>

        <div class="testimonial-author">
          <img
            v-if="item.avatarUrl"
            :src="item.avatarUrl"
            :alt="`Foto de ${item.author}`"
            class="testimonial-avatar"
            loading="lazy"
          />
          <span v-else class="testimonial-avatar testimonial-initials" aria-hidden="true">
            {{ initialsOf(item.author) }}
          </span>

          <span class="testimonial-meta">
            <strong>{{ item.author }}</strong>
            <small>{{ item.role }}</small>
          </span>

          <span class="testimonial-area">{{ item.area }}</span>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
import { Quote } from 'lucide-vue-next';

/**
 * Testimonios publicables. Cada entrada exige:
 *  - `consent: true`  → autorización explícita del cliente para publicarlo.
 *  - `avatarUrl: ''`  → sin foto real; se muestran las iniciales, que es la vía
 *                       para proteger la identidad cuando el cliente lo pide.
 *  - `area`           → 'Impresión 3D' | 'Automatización' | 'Aplicativos web'.
 *
 * Se mantiene aquí hasta que exista un endpoint de administración.
 */
const TESTIMONIALS = [
  // {
  //   id: 1,
  //   quote: '…',
  //   author: '…',
  //   role: '…',
  //   area: 'Impresión 3D',
  //   avatarUrl: '',
  //   consent: true,
  // },
];

export default {
  name: 'TestimonialsSection',
  components: { Quote },
  data() {
    return {
      // Solo se publican los que tienen consentimiento registrado.
      testimonials: TESTIMONIALS.filter((t) => t.consent),
    };
  },
  methods: {
    initialsOf(name) {
      return (name || '')
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0].toUpperCase())
        .join('');
    },
  },
};
</script>

<style scoped>
.testimonials-head {
  max-width: 46rem;
  margin-bottom: var(--space-lg);
}

.testimonials-title {
  font-family: var(--font-subtitle);
  font-weight: 700;
  font-size: 40px;
  line-height: 1.1;
  color: var(--color-title);
  margin: 0 0 var(--space-sm) 0;
}

.testimonials-intro {
  font-family: var(--font-body);
  font-size: 20px;
  line-height: 1.5;
  color: var(--color-text);
  margin: 0;
}

.testimonials-grid {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-md);
}

.testimonial-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
  padding: var(--space-md);
  background-color: var(--color-white);
  border: 1px solid var(--color-border);
  border-radius: 16px;
}

.testimonial-icon {
  color: var(--color-brand);
}

.testimonial-quote {
  font-family: var(--font-body);
  font-size: 18px;
  line-height: 1.5;
  color: var(--color-text-strong);
  margin: 0;
  flex: 1;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.testimonial-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.testimonial-initials {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-brand);
  color: var(--color-white);
  font-family: var(--font-subtitle);
  font-weight: 700;
  font-size: 16px;
}

.testimonial-meta {
  display: flex;
  flex-direction: column;
  font-family: var(--font-body);
  color: var(--color-text);
}

.testimonial-meta strong {
  color: var(--color-title);
  font-size: 17px;
}

.testimonial-meta small {
  font-size: 15px;
}

.testimonial-area {
  margin-left: auto;
  font-family: var(--font-body);
  font-size: 14px;
  color: var(--color-brand);
  background-color: rgba(46, 138, 153, 0.08);
  border: 1px solid rgba(46, 138, 153, 0.25);
  border-radius: 9999px;
  padding: 0.2rem 0.7rem;
}

@media (max-width: 1024px) {
  .testimonials-grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 800px) {
  .testimonials-title { font-size: 1.75rem; text-align: center; margin-bottom: var(--space-md); }
  .testimonials-head { text-align: center; }
  .testimonials-grid { grid-template-columns: 1fr; }
}
</style>
